import URL from '../url'
import Request from '../request'

export const courseStatisticsListService = query =>
  new Request(URL.API, URL.COURSE_STATISTICS_LIST).post(query)
